import { LibraryDeleteConfirmDialog } from '@/features/library/components/LibraryDeleteConfirmDialog'

type Props = Readonly<{
  open: boolean
  onCancel: () => void
  onConfirm: () => void
  isPending?: boolean
}>

export function BuiltInInstrumentRemoveDialog({
  open,
  onCancel,
  onConfirm,
  isPending = false,
}: Props) {
  return (
    <LibraryDeleteConfirmDialog
      open={open}
      title="Are you sure you want to remove this instrument from the Library?"
      onCancel={onCancel}
      onConfirm={onConfirm}
      isPending={isPending}
      dialogTestId="built-in-instrument-remove-dialog"
      cancelTestId="built-in-instrument-remove-cancel"
      confirmTestId="built-in-instrument-remove-confirm"
    />
  )
}
